import React, { Fragment } from "react";
import { Card, CardBody, Col, Container, Row, Table } from "reactstrap";
import useSubLedgerTypeListController from "./SubLedgerTypeList.controller";
import { Breadcrumbs } from "../../../../../AbstractElements";
import HeaderCard from "../../../../Common/Component/HeaderCard";
import DataTableComponent from "../../../../Common/Component/DataTableComponent";
import ViewModal from "../../../../Common/Component/ViewModal";
import {
    Code,
    DateCreated,
    DateModified,
    GeneralLedgerAccount,
    Settings,
} from "../../../../../Constant";
import {
    Description,
    GeneralLedgerClass,
    GeneralLedgerGroup,
    GeneralLedgerType,
    Name,
    Status,
    SubLedgerClass,
} from "../../../../../Constant";
import { ISubLedgerTypesResponse } from "../SubLedgerType.types";
import { formatDateWithTimeZone } from "../../../../../_helper/dateHelper";

const SubLedgerTypeList = () => {
    const {
        data,
        tableColumns,
        newBtn,
        editMode,
        selectedRowData,
        viewModalOpen,
        formFields,
        title,
        addToDefaultAction,
        setViewModalOpen,
        handleView,
        handleEdit,
        memoizedHandleEdit,
    } = useSubLedgerTypeListController();

    return (
        <Fragment>
            <Breadcrumbs parent={Settings} title={title} mainTitle={title} />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <HeaderCard
                                title={title}
                                btnUrl={newBtn}
                                span1={undefined}
                                span2={undefined}
                                mainClasses={undefined}
                            />
                            <CardBody>
                                <DataTableComponent
                                    tabledata={data}
                                    tableColumns={tableColumns}
                                    isLoading={false}
                                    onView={handleView}
                                    // onDelete={handleDelete}
                                    onEdit={handleEdit}
                                    useTableAction={undefined}
                                    addToDefaultAction={addToDefaultAction}
                                    onDelete={undefined}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <ViewModal
                    isOpen={viewModalOpen}
                    toggle={() => setViewModalOpen(!viewModalOpen)}
                    onSubmit={undefined}
                    editMode={editMode}
                    formFields={formFields}
                    onEdit={memoizedHandleEdit}
                    rowData={selectedRowData}
                    modalTitle={undefined}
                >
                    {selectedRowData && (
                        <>
                            <Table>
                                <tbody>
                                    <tr className="border-bottom-primary">
                                        <th scope="row">{Name}</th>
                                        <td>{selectedRowData.name}</td>
                                    </tr>

                                    <tr className="border-bottom-primary">
                                        <th scope="row">{Code}</th>
                                        <td>{selectedRowData.code}</td>
                                    </tr>

                                    <tr className="border-bottom-primary">
                                        <th scope="row">{Description}</th>
                                        <td>{selectedRowData.description}</td>
                                    </tr>

                                    <tr className="border-bottom-primary">
                                        <th scope="row">
                                            {GeneralLedgerGroup}
                                        </th>
                                        <td>
                                            {
                                                selectedRowData.sl_class.gl_group
                                                    .name
                                            }
                                        </td>
                                    </tr>

                                    <tr className="border-bottom-primary">
                                        <th scope="row">{SubLedgerClass}</th>
                                        <td>{selectedRowData.sl_class.name}</td>
                                    </tr>

                                    <tr className="border-bottom-primary">
                                        <th scope="row">
                                            {GeneralLedgerGroup}
                                        </th>
                                        <td>
                                            {
                                                selectedRowData.gl_account
                                                    .gl_type.gl_class.gl_group
                                                    .name
                                            }
                                        </td>
                                    </tr>

                                    <tr className="border-bottom-primary">
                                        <th scope="row">
                                            {GeneralLedgerClass}
                                        </th>
                                        <td>
                                            {
                                                selectedRowData.gl_account
                                                    .gl_type.gl_class.name
                                            }
                                        </td>
                                    </tr>

                                    <tr className="border-bottom-primary">
                                        <th scope="row">{GeneralLedgerType}</th>
                                        <td>
                                            {
                                                selectedRowData.gl_account
                                                    .gl_type.name
                                            }
                                        </td>
                                    </tr>

                                    <tr className="border-bottom-primary">
                                        <th scope="row">
                                            {GeneralLedgerAccount}
                                        </th>
                                        <td>
                                            {selectedRowData.gl_account.name}
                                        </td>
                                    </tr>

                                    <tr className="border-bottom-primary">
                                        <th scope="row">{Status}</th>
                                        <td>
                                            {selectedRowData.is_active ? (
                                                <span className="badge badge-light-success">
                                                    Active
                                                </span>
                                            ) : (
                                                <span className="badge badge-light-danger">
                                                    Inactive
                                                </span>
                                            )}
                                        </td>
                                    </tr>

                                    <tr className="border-bottom-secondary">
                                        <th scope="row">{DateCreated}</th>
                                        <td>
                                            {formatDateWithTimeZone(
                                                selectedRowData.created_at
                                            )}
                                        </td>
                                    </tr>

                                    <tr className="border-bottom-secondary">
                                        <th scope="row">{DateModified}</th>
                                        <td>
                                            {formatDateWithTimeZone(
                                                selectedRowData.updated_at
                                            )}
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </>
                    )}
                </ViewModal>
            </Container>
        </Fragment>
    );
};

export default SubLedgerTypeList;

export const StatusRow = (row: ISubLedgerTypesResponse) => {
    return row.is_active ? (
        <span className="badge badge-light-success">Active</span>
    ) : (
        <span className="badge badge-light-danger">Inactive</span>
    );
};
